// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PdpSharedBlurb__wrapper__a3a350c8","icon":"PdpSharedBlurb__icon__a3a350c8","text":"PdpSharedBlurb__text__a3a350c8"};